import React, { useEffect } from 'react'
import NeuroAssessmentForm from './neuroAssessmentForm';
import AssessmentLayout from '../AssessmentLayout';

const NeuroAssessment = (props) => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, []);

  const redirectBack = () => {
    const { history, shiftReport } = props
    history.push(`/shift-report/clinical/v1/${shiftReport.id}/edit`);
  }

  const redirectToCardioAssesssment = () => {
    const { history, shiftReport } = props
    history.push(`/shift-report/clinical/v1/${shiftReport.id}/assessment/cardiovascular`);
  }

  return (
    <AssessmentLayout {...props}>
        <h3 className="block text-gray-600 text-3xl mb-6">Assessment - Neurological</h3>
        <div className="bg-white justify-between rounded-lg shadow-md">
          <NeuroAssessmentForm 
            onCancel={redirectBack} 
            onContinue={redirectToCardioAssesssment}
            onSubmit={props.updateAssessment}
            assessment={props.assessment}
          />
        </div>
    </AssessmentLayout>
  );
}

export default NeuroAssessment;
